/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {

    hideDropdown($(this));
    
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
        setTimeout(function() {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
        }, 200);
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;
  
  
  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $stockIndicator = $("[data-stock]"),
  	  $totalBesparelse = $("#totalSavingPercentProduct"),
      $imageStockIndicator = $("#productStockOnImage");

  if (variant) {
    
    var stockLabelTarget = document.querySelector('.Productpage__variantSelectionHeader');
    
    if (!stockLabelTarget.hasAttribute('data-default')) {
      stockLabelTarget.removeAttribute('data-visibility-hidden');
    } else {
      stockLabelTarget.removeAttribute('data-default');
    }

    var totalBesparelse = Math.round((variant.compare_at_price - variant.price)/ variant.compare_at_price * 100) + "%";

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available && variant.inventory_quantity > 3) {
      $("#booster-button").hide();
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Tilføj til kurv \u0026rarr;");
      $quantityElements.show();
      $stockIndicator.attr('data-stock', 'available');
      
      $imageStockIndicator.addClass("greenDot").removeClass("redDot");
    } else if (variant.available && variant.inventory_quantity > 0 || variant.available && variant.inventory_management === null) {
            $("#booster-button").hide();
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Tilføj til kurv \u0026rarr;");
      $quantityElements.show();
      $stockIndicator.attr('data-stock', 'limited');
      $imageStockIndicator.addClass("greenDot").removeClass("redDot").removeClass("greenDot");
    }   
    else {
      $("#booster-button").show();
      // Sold out, disable the submit button, change text, hide quantity elements      
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Udsolgt");
      $quantityElements.hide();
      
      $stockIndicator.attr('data-stock', 'unavailable');
      
      $imageStockIndicator.addClass("redDot").removeClass("greenDot").removeClass("orangeDot");
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) ); 
    
    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      
      $totalBesparelse.html(totalBesparelse);
      $(".du-sparer").show();
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $totalBesparelse.hide();
      $(".du-sparer").hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("VÆLG STØRRELSE");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
        timber.cache.$thumbImages.on('mouseenter', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');
    
    this.$nodes.moved.removeClass('is-transitioning');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();



// Initialize Timber's JS on docready
$(timber.init);


if (typeof WDN === 'undefined') {
  var WDN = {};
}

if (typeof WDN.Helpers === "undefined") {
  WDN.Helpers = (function () {
    // pub
    var PageProcess, Debounce, OptimizeImage;

    PageProcess = (function () {
      var List = {};
      var Names = {
        parent: "Progressbar",
        target: "Progressbar__fill",
      };
      var Config = {
        debounceWait: 1,
      };
      var Helpers = {};
      Helpers.parentFromId = function (id) {
        return document.querySelector(`.${Names.parent}[data-id="${id}"]`);
      };
      Helpers.parentIsFound = function (id) {
        var target = Helpers.parentFromId(id);
        return !!target;
      };
      var Progressbar = function (id) {
        this.id = id;
        this.parent = Helpers.parentFromId(this.id);
        this.target = this.parent.querySelector(`.${Names.target}`);
        this.listenForScroll();
      };
      Progressbar.prototype.hide = function () {
        this.target.style.display = "none";
      };
      Progressbar.prototype.show = function () {
        this.target.style.display = "block";
      };
      Progressbar.prototype.update = function (progress) {
        if (typeof progress == "number") {
          if (progress > 10) {
            this.show();
            this.target.style.width = `${progress}%`;
          } else {
            this.hide();
          }
        }
      };
      Progressbar.prototype.getOffset = function () {
        this.update(WDN.Page.ScrollOffset().percentage);
      };
      Progressbar.prototype.listenForScroll = function () {
        // Only done to maintain scope
        var Offset = this.getOffset.bind(this);
        // Setup listener
        window.addEventListener(
          "scroll",
          WDN.Debounce(Offset, Config.debounceWait)
        );
      };
      // Create function
      var Create = function (id) {
        // If element on page found
        if (Helpers.parentIsFound(id)) {
          List[id] = new Progressbar(id);
        } else {
          console.warn(`No parent found for item with id: ${id}`);
        }
      };
      return {
        Create: Create,
      };
    })();

    Debounce = function (Function, WaitTime) {
      // Named function to start / clear timer
      var Timer;
      return function () {
        var This = this,
            args = arguments;
        var later = function () {
          Timer = null;
          Function.apply(This, args);
        };
        clearTimeout(Timer);
        Timer = setTimeout(later, WaitTime);
      };
    };

    OptimizeImage = function (image, size) {
      var imageSize = "_" + size + "x";
      var exstension = "." + image.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[1];
      var optimized = image.replace(exstension, imageSize + exstension);
      return optimized;
    };

    return {
      PageProcess: PageProcess,
      Debounce: Debounce,
      OptimizeImage: OptimizeImage,
    };
  })();
}

if (typeof WDN.Dropdown === 'undefined') {
  WDN.Dropdown = (function () {
    var Init, Dropdown, CollapseAllContainers;

    var OnOpenCallback, OnCloseCallback, WindowOnResize;
    var SetUpWindowListener, RecalculateDropdowns;

    var Dropdowns = {};

    Dropdown = function (trigger) {
      this.trigger = trigger;
      this.for = trigger.dataset.for;
      this.container = document.querySelector(
        '[data-dropdown-container][data-for="' + this.for + '"]'
      );
      this.group = this.container.dataset.dropdownGroup || false;
      this.content = this.container.querySelector('[data-dropdown-content]');
      this.bind();
      this.setInitialState();
    };

    Dropdown.prototype.setInitialState = function () {
      if (typeof this.trigger.dataset['dropdown-Open'] !== 'undefined') {
        this.container.style.height = this.content.offsetHeight + 'px';
      }
    };

    Dropdown.prototype.bind = function () {
      this.trigger.addEventListener('click', this.clickHandler.bind(this));
    };

    Dropdown.prototype.clickHandler = function (e) {
      e ? e.preventDefault() : '';
      if (this.trigger.dataset['dropdown-Open'] == '') {
        this.collapse();
      } else {
        this.open();
      }
    };

    Dropdown.prototype.collapse = function () {
      this.trigger.removeAttribute('data-dropdown--open', '');
      this.container.style.height = 0 + 'px';
      typeof this.onClose === 'function' ? this.onClose() : '';
      typeof OnCloseCallback === 'function' ? OnCloseCallback() : '';
    };

    Dropdown.prototype.open = function () {
      this.collapseRest();
      this.trigger.setAttribute('data-dropdown--open', '');
      this.container.style.height = this.content.offsetHeight + 'px';
      typeof this.onOpen === 'function' ? this.onOpen() : '';
      typeof OnOpenCallback === 'function' ? OnOpenCallback() : '';
    };

    Dropdown.prototype.collapseRest = function () {
      if (this.group) {
        this.collapseGroup();
      } else {
        CollapseAllContainers();
      }
    };

    Dropdown.prototype.collapseGroup = function () {
      var triggers = document.querySelectorAll(
        "[data-dropdown-trigger][data-dropdown-group='" + this.group + "']"
      );
      var containers = document.querySelectorAll(
        "[data-dropdown-container][data-dropdown-group='" + this.group + "']"
      );
      triggers.forEach(function (trigger, i) {
        if (typeof trigger.dataset.dropdownFreeze === 'undefined') {
          trigger.removeAttribute('data-dropdown--open');
          containers[i].style.height = 0 + 'px';
        }
      });
    };

    CollapseAllContainers = function () {
      var containers = document.querySelectorAll('[data-dropdown-container]');
      var triggers = document.querySelectorAll('[data-dropdown-trigger]');

      containers.forEach(function (item, i) {
        var triggerDataset = triggers[i].dataset;
        if (typeof triggerDataset.dropdownFreeze === 'undefined') {
          triggers[i].removeAttribute('data-dropdown--open');
          item.style.height = 0 + 'px';
        }
      });
    };

    SetUpWindowListener = function () {
      window.addEventListener('resize', WDN.Helpers.Debounce(WindowOnResize, 500));
    };

    WindowOnResize = function () {
      RecalculateDropdowns();
    };

    RecalculateDropdowns = function () {
      for (var key in Dropdowns) {
        if (Dropdowns.hasOwnProperty(key)) {
          Dropdowns[key].setInitialState();
        }
      }
    };
    Init = function (obj) {
      var triggers = document.querySelectorAll('[data-dropdown-trigger]');
      if (triggers.length > 0) {
        triggers.forEach(function (trigger) {
          var id = trigger.dataset.for;
          if (!Dropdowns[id]) {
            var newInstance = new Dropdown(trigger);
            Dropdowns[id] = newInstance;
          }
        });
        if (obj) {
          OnOpenCallback = obj.onOpen || false;
          OnCloseCallback = obj.onClose || false;
        }
        SetUpWindowListener();
      }
    };

    Init();

    return {
      init: Init,
      List: Dropdowns,
    };
  })();
}